import { render, staticRenderFns } from "./CountCard.vue?vue&type=template&id=6a68c886&scoped=true&"
import script from "./CountCard.vue?vue&type=script&lang=js&"
export * from "./CountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a68c886",
  null
  
)

export default component.exports